import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RouterNavigationService {
  constructor(private router: Router) {}

  navigateOrOpenInNewTab(
    route: any[],
    options: {
      state?: any;
      storage?: Record<string, string | null>;
      event?: MouseEvent;
    } = {}
  ) {
    // Session/local storage
    if (options.storage) {
      Object.entries(options.storage).forEach(([key, value]) => {
        if (value === null) {
          sessionStorage.removeItem(key);
        } else {
          sessionStorage.setItem(key, value);
        }
      });
    }

    const url = this.router.serializeUrl(this.router.createUrlTree(route));
    const fullUrl = window.location.origin + url;

    if (options.event?.ctrlKey || options.event?.metaKey || options.event?.button === 1) {
      // Ctrl+Click or Cmd+Click => new tab
      window.open(fullUrl, '_blank');
    } else {
      // Default navigation
      this.router.navigate(route, { state: options.state });
    }
  }
}
